import React, { useState, useEffect } from "react";
import ApiBasketTemp from "../../../../core/api/api.basketTemp";
import _ from "lodash";
import UserOrderPersonIndex from "./UserOrderPerson/UserOrderPersonIndex";
import NewBasketItemsIndex from "./BasketItems/NewBasketItemsIndex";
import { useParams } from "react-router-dom";


export const ViewNewBasketContents = () => {

  //PART 1 --------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  const [count, setCount] = useState(0) //----------------------------------------useEffect  هر گونه تغییری در مقدار ان باعث اجرای میشود
  const [bascketPersons, setBascketPersons] = useState([])
  const [service, setService] = useState({});
  const [basketItems, SetBasketItems] = useState([])

  // PART 2----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  let { id } = useParams();

  // -------------دریافت سفارشات و اطلاعات از بک اند --------------------------------------------------------------------

  useEffect(() => {
    (async () => {
      try {
        if (id !== undefined) {
          const viewOrderContents = await ApiBasketTemp.getBasketTempById(id);
          setService(viewOrderContents);
          SetBasketItems(viewOrderContents.basketItems)
          setBascketPersons(viewOrderContents.basketPersons)

        } else {
          setService({});
        }
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, [count]);


  const callBackJustForRunUseEffect = () => {
    setCount(c => c + 1)
  }

  // ===============================================================================
  return (
    <div className=" m-0 p-0 ">
      {/* ----------------------سفارش دهنده ----------------------------------------- */}
      <UserOrderPersonIndex service={service} callBack={callBackJustForRunUseEffect} basketId={id} />
      {/* ===========================لیست ایتم ها  ======================================================================== */}
      <NewBasketItemsIndex service={service} basketItems={basketItems} basketId={id} callBack={callBackJustForRunUseEffect} bascketPersons={bascketPersons} />
      {/* ==============افراد وابسته به سفارش  ============================================================================== */}
      {/* <BasketPersonIndex bascketPersons={bascketPersons} service={service} basketId={id} callBack={callBackJustForRunUseEffect} /> */}
    </div>
  );
};

export default ViewNewBasketContents;

